<div class="preview-box">
  <div class="text-right">
    หน้า 1 / 1
  </div>

  <div class="row no-gutters align-items-center">
    <div class="col-auto">
      <img [src]="logo || 'etax/apps/templates/tax_data/resources/logo.png'" class="img-logo">
    </div>
    <div class="col">
      <span class="company-name">{{ detail.name_th }}</span>
      <span class="company-name" *ngIf="detail.name_en">/ {{ detail.name_en }}</span>
      <br>
      <span>{{ detail.address_th }} {{ detail.post_code }}</span>
      <br>
      <span *ngIf="detail.address_en">{{ detail.address_en }} {{ detail.post_code }}</span>
      <br>
    </div>
  </div>

  <div class="ml-auto" style="width: 60%;">
    <table class="table-info">
      <tbody>
        <tr>
          <td class="text-center">
            <span class="text-bold">
              เอกสารตัวอย่าง<br>
              Sample Document
            </span>
          </td>
          <td class="text-center">
            &nbsp; <span class="text-bold">เลขที่ / No.</span> &nbsp; 1
          </td>
        </tr>
        <tr>
          <td colspan="2" class="text-center">
            <span class="text-bold">เลขประจำตัวผู้เสียภาษีผู้ขาย / Seller TAX ID.</span> &nbsp;
            {{ detail.tax_id }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/preview-logo/preview-logo.component.html